import(/* webpackMode: "eager" */ "/app/src/app/brand/page.tsx");
